import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-report",
  "use": "icon-report-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 64 64\" id=\"icon-report\">\r\n<path d=\"M19.1,32.5h26.5v-6.6H19.1V32.5z M55.6,13.8V6h-6.6v6.6h-6.6V6h-6.6v6.6h-6.6V6h-6.6v6.6h-6.6V6H9.2v7.8\r\n\tc-2,1.1-3.3,3.2-3.3,5.5v33.1c0.3,3.9,3.7,6.9,7.6,6.6h37.8c3.9,0.2,7.3-2.7,7.6-6.6V19.2C58.8,16.9,57.5,14.9,55.6,13.8z\r\n\t M52.2,52.3H12.5V19.2h39.7V52.3z M19.1,45.7h26.5v-6.6H19.1V45.7z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/report.svg
// module id = 2nwU
// module chunks = 221